<template>
  <v-card
    style="min-width: 650px"
    elevation="0"
  >
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <img :src="LMSdata.img" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">
              Unlink "{{ LTIdata.contentName }}"
            </span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card elevation="0">
      <v-card-title>
        Are you sure that you would like to unlink "{{ LTIdata.contentName }}"?
        <v-btn
          v-if="LTIdata.render_path !== 'playlist'"
          flat
          text
          class="branded-text"
          @click="downloadLTIData"
        >
          Download Data
        </v-btn>
      </v-card-title>
      <v-card-text>
        For more information on unlinking
        {{ LTIdata.render_path === 'playlist' ? 'playlists' : 'bulbs' }} click
        <a
          class="branded-color"
          target="_blank"
          :href="unlinkKnowledgeBase"
        >
          here
        </a>.
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-card-actions
      class="row-space"
      style="height: 56px"
    >
      <v-btn
        flat
        class="branded-grey"
        @click="setDashModal(null)"
        >
          Cancel
      </v-btn
      >
      <div class="row-center">
        <v-btn
          class="branded-background text-white"
          :loading="simpleDashLoading"
          @click="confirm()"
        >
          Unlink
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
/* global _ */
/**
 * Popover modal to confirm unlinking when selecting the bulb or playlist to unlink from a dash table (Bulbs, Admin Action Button, Playlist)
 * not used when unlinking from the greyscreens (already linked)
 **/

import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import {
  LTI_RENDER_PATHS,
} from '@Constants';

import _ from 'lodash';

export default {
  name: 'ConfirmUnlink',
  props: [
    'archiveClass',
  ],
  computed: {
    ...mapGetters([
      'LTIdata',
      'LMSdata',
      'simpleDashLoading',
    ]),
    ...mapGetters('instructors', [
      'instructorAjaxing',
    ]),
    unlinkKnowledgeBase() {
      if (this.LTIdata.render_path === LTI_RENDER_PATHS.Playlist) {
        return 'https://knowledge.playposit.com/article/284-how-to-link-a-playlist-in-your-lms#unlink-relink';
      }
      return 'https://knowledge.playposit.com/article/130-how-to-link-unlink-bulbs-in-lms';
    },
  },
  methods: {
    ...mapActions([
      'unlinkBulb',
      'unlinkPlaylist',
    ]),
    ...mapMutations([
      'setDashModal',
    ]),
    ...mapMutations('intstructor', [
      'exportDataTable',
    ]),
    confirm() {
      if (this.LTIdata.render_path === LTI_RENDER_PATHS.Playlist) {
        this.unlinkPlaylist({
          playlistId: this.LTIdata.contentId,
          sectionId: this.LTIdata.section_id,
          isContentItemLaunch: this.LTIdata.isContentItemLaunch,
        });
      } else {
        this.unlinkBulb({
          bulb_id: this.LTIdata.contentId,
          section_id: this.LTIdata.section_id,
          render_path: this.LTIdata.render_path,
          content_item_launch: this.LTIdata.isContentItemLaunch,
        });
      }
    },
    downloadLTIData() {
      this.exportDataTable({
        type: 'Interactions',
        section_id: this.LTIdata.section_id,
        bulb_id: this.LTIdata.contentId,
      });
    },
  },
};
</script>
